import { FlexBox, Icon, Text } from '@fable/components'
import { ProgressCircle, TextCounter } from '../shared'
import { StatsUserImage } from '../StatsUserImage'
import { css, cx, useTheme } from '@fable/theme'
import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { useStats } from '../../lib/ctx/stats'
import { getReadingGoalResult } from '../../lib/utils'

export const StatsHeroReadingGoal = () => {
  const [theme, stats, isProfileView, year] = useStats((s) => [
    s.theme,
    s.stats,
    s.isProfileView,
    s.year,
  ])
  const { colors } = useTheme()
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, amount: 1 })
  const { numBooks, booksRead, percentage } = getReadingGoalResult({
    stats,
  })
  const subtitleMotion = css`
    transition: color 0.6s ease-in-out;
  `

  const getTextColor = () => {
    if (theme.key === 'blue' || theme.key === 'green' || theme.key === 'pink') {
      return colors.uiWhite
    }

    return theme.summaryText
  }

  const textColor = getTextColor()

  return (
    <>
      <FlexBox
        ref={ref}
        className={css`
          position: absolute;
          top: ${isProfileView ? 1 : -16}px;
          left: 50%;
          transform: translateX(-50%);
        `}
        centerAll
      >
        <ProgressCircle
          percentage={inView ? percentage : 0}
          width={isProfileView ? 80 : 166}
          strokeWidth={isProfileView ? 20 : 14}
          transitionDelay={0.4}
          cutout
        />
      </FlexBox>
      {isProfileView ? (
        <FlexBox
          className={css`
            width: 40px;
            height: 40px;
            background-color: ${colors.uiWhite};
            border-radius: 50%;
          `}
          centerAll
        >
          <Icon
            type="trophy"
            className={css`
              width: 20px;
            `}
            fill={theme.accent}
          />
        </FlexBox>
      ) : (
        <StatsUserImage />
      )}
      <FlexBox
        className={css`
          padding: 0 20px;
          width: 100%;
          margin-top: 20px;
        `}
        alignItems="center"
        flexDirection="column"
      >
        <Text
          className={subtitleMotion}
          type="body"
          sizing="M"
          color={textColor}
          align="center"
          weight="500"
        >
          {year} Reading Goal
        </Text>
        <Text
          className={css`
            width: 100%;
            margin-top: 2px;
            margin-bottom: -4px;
          `}
          type="header"
          tag="h2"
          custom={{ fontSize: '48px', lineHeight: '48px' }}
          color={colors.uiWhite}
          align="center"
          weight="500"
        >
          <TextCounter to={booksRead} delay={0.42} />
          &nbsp;
          <span
            className={css`
              opacity: 50%;
            `}
          >
            of {numBooks}
          </span>
        </Text>
        <Text
          className={cx(
            css`
              opacity: 0.75;
            `,
            subtitleMotion
          )}
          type="body"
          sizing="M"
          color={textColor}
          align="center"
          weight="500"
        >
          books
        </Text>
      </FlexBox>
    </>
  )
}
